import { render, staticRenderFns } from "./payslip-body.vue?vue&type=template&id=77948dd5&scoped=true&"
import script from "./payslip-body.vue?vue&type=script&lang=js&"
export * from "./payslip-body.vue?vue&type=script&lang=js&"
import style0 from "./payslip-body.vue?vue&type=style&index=0&id=77948dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77948dd5",
  null
  
)

export default component.exports